<template>
  <WdsText class="tw-text-right">
    {{ column.currency }} {{ column.rate?.toLocaleString(locale) ?? '' }}
    <br />
    {{ rateType }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { textHelpers } from '@/utils/tools'

const locale = currentLocale

const RateColumn = graphql(`
  fragment RateColumnHire on Hire {
    rate
    rateType
    currency
    hasMilestones
  }
  fragment RateColumnJob on Job {
    rate
    rateType
    currency
  }
`)

const props = defineProps<{ row: FragmentType<typeof RateColumn> }>()
const column = computed(() => useFragment(RateColumn, props.row))
const rateType = computed(() => {
  if (column.value.hasMilestones) {
    return 'Milestones'
  }
  const read = textHelpers.keyToHumanReadable(column.value.rateType ?? '')
  if (read !== null && read.length > 0) {
    return textHelpers.capitalizeFirstLetter(read)
  }
  return read ?? ''
})
</script>
